const creditBrand = [
  "Elo",
  "Mastercard",
  "Visa",
  "Amex",
  "JCB",
  "Aura",
  "Hipercard",
  "Diners",
  "Discover",
];

const voucherBrand = ["Alelo", "VR", "Sodexo"];

const monthRange = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const address = {
  type: "object",
  properties: {
    line1: { type: "string" },
    line2: { type: "string" },
    zipCode: { type: "string" },
    city: { type: "string" },
    state: { type: "string" },
    country: { type: "string" },
  },
  additionalProperties: false,
};

const Options = {
  type: "object",
  properties: {
    verifyCard: { type: "boolean" },
  },
  additionalProperties: false,
};

const CardSchema = {
  type: "object",
  additionalProperties: false,
  required: ["number", "holderName", "expMonth", "expYear"],
  properties: {
    number: { type: "string", minLength: 13, maxLength: 19 },
    holderName: { type: "string", maxLength: 64 },
    holderDocument: { type: "string" },
    expMonth: { enum: [...monthRange] },
    expYear: {
      type: "number",
      maximum: 9999,
      minimum: new Date().getFullYear(),
    },
    cvv: { type: "string", minLength: 3, maxLength: 4 },
    brand: {
      enum: [...creditBrand, ...voucherBrand],
    },
    privateLabel: { type: "boolean" },
    billingAddress: address,
    options: Options,
  },
};

module.exports = {
  CardSchema,
};
